(function ($) {
  const selector = '.Plugin--EventsList .Event, .SolrResult--News .Event';
  if ($(selector).length) {
    $.ajax({
      dataType: 'json',
      url: '/index.php?type=69',
    }).done(function (data) {
      if (data.latitude && data.longitude) {
        let userLatRad = (data.latitude * Math.PI) / 180;
        let userLongRad = (data.longitude * Math.PI) / 180;
        let R = 6378.137; // Radius of earth in KM

        $(selector).each(function () {
          let eventCountryCode = $(this).attr('data-country-code');
          if (['', 'CH'].indexOf(eventCountryCode) === -1) return;

          let eventLatRad = ($(this).attr('data-latitude') * Math.PI) / 180;
          let eventLongRad = ($(this).attr('data-longitude') * Math.PI) / 180;

          if (eventLatRad * eventLongRad > 0) {
            let dLat = userLatRad - eventLatRad;
            let dLon = userLongRad - eventLongRad;
            let a =
              Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(eventLatRad) *
                Math.cos(userLatRad) *
                Math.sin(dLon / 2) *
                Math.sin(dLon / 2);
            if (R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) <= 50) {
              $(this).addClass('Location--Close');
            }
          }
        });
      }
    });
  }
})(jQuery);
